
    <set-widget (widgetEvent)="forwardEvent($event)" [entity]="this.entity" [layout]="this.layout" [options]="options" [title]="'Outgoing Subscribers'"></set-widget>
  